export default "__VITE_ASSET__BpdZiAr0__"